
function initSystemMessages() {
(function ($) {
  $(document).ready(function() {
    setTimeout(function(){
      $('.system-messages').prepend("<div class='close-button'></div>");
      $('.system-messages .close-button').click(function() {
        $(this).parent().fadeOut(300);
      });
    }, 1500);
  }); 
})(jQuery);
}

export{initSystemMessages}
